import { SubmitButton, MutateButton } from "@imago/api-client-for-react"
import { useGAHTIntaken, useGAHTIntake, useFakeGAHTIntake, FormDialog } from "../../FormDialog.tsx"
export { useGAHTIntaken as useIntaken }

function _Intake() {
	const intake = useGAHTIntake()

	return <>
		<form>
			<p>To help you, we need to ask you some questions. Please give yourself 15 minutes to complete this form.</p>
			<p>The better we know you, the more efficient treatment we’ll be able to provide.</p>
			<div className="row">
				<SubmitButton mutation={intake} vars={data => {}}>Fill out the intake form</SubmitButton>
			</div>
		</form>
		<FormDialog mutation={intake}/>
	</>
}

export function Intake() {
	const done = useGAHTIntaken()
	const fakeIntake = useFakeGAHTIntake()

	return <section data-done={done ? true : undefined}>
		<hgroup>
			<h2>Tell us about yourself</h2>
			{!done ?
				<MutateButton className="secondary" mutation={fakeIntake}>TEST: Skip</MutateButton>
			: <></>}
		</hgroup>
		{!done ? <_Intake/> : <></>}
	</section>
}
